<template>
  <div class="textFieldDialog">
    <el-checkbox-group 
      v-model="active"
      :min="1"
      :max="3"
    >
      <el-checkbox v-for="(item, index) in list" :label="item.name" :key="index">{{ item.label }}</el-checkbox>
    </el-checkbox-group>
    <div class="footer">
      <el-button type="primary" size="small" @click="submint">确认</el-button>
      <el-button type="info" size="small" @click="close">取消</el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'textFieldDialog',
  data() {
    return {
      active: [],
      list: [{
        id: 1,
        label: '马克思主义、列宁主义、毛泽东思想、邓小平理论',
        name: 'A',
      },
      {
        id: 2,
        label: '哲学、宗教',
        name: 'B',
      },
      {
        id: 3,
        label: '社会科学总论',
        name: 'C',
      },
      {
        id: 4,
        label: '政治、法律',
        name: 'D',
      },
      {
        id: 5,
        label: '军事',
        name: 'E',
      },
      {
        id: 6,
        label: '经济',
        name: 'F',
      },
      {
        id: 7,
        label: '文化、科学、教育、体育',
        name: 'G',
      },
      {
        id: 8,
        label: '语言、文字',
        name: 'H',
      },
      {
        id: 9,
        label: '文学',
        name: 'I',
      },
      {
        id: 10,
        label: '艺术',
        name: 'J',
      },
      {
        id: 11,
        label: '历史、地理',
        name: 'K',
      },
      {
        id: 12,
        label: '自然科学总论',
        name: 'N',
      },
      {
        id: 13,
        label: '数理科学和化学',
        name: 'O',
      },
      {
        id: 14,
        label: '天文学、地球科学',
        name: 'P',
      },
      {
        id: 15,
        label: '生物科学',
        name: 'Q',
      },
      {
        id: 16,
        label: '医药、卫生',
        name: 'R',
      },
      {
        id: 17,
        label: '农业科学',
        name: 'S',
      },
      {
        id: 18,
        label: '工业技术',
        name: 'T',
      },
      {
        id: 19,
        label: '交通运输',
        name: 'U',
      },
      {
        id: 20,
        label: '航空、航天',
        name: 'V',
      },
      {
        id: 21,
        label: '环境科学、安全科学',
        name: 'X',
      },
      {
        id: 22,
        label: '综合性图书',
        name: 'Z',
      }],
    }
  },
  created() {
    this.active = JSON.parse(localStorage.getItem('domains')) || [];
  },
  methods: {
    submint() {
      localStorage.setItem('domains', JSON.stringify(this.active));
      this.close();
    },
    close() {
      window.close();
    },
  }
}
</script>

<style scoped>
.textFieldDialog {
  padding: 20px;
}

label {
  display: block;
}

.footer {
  padding: 20% 20px 0;
  float: right;
  /* margin: auto; */
}
</style>